import { render, staticRenderFns } from "./per_page_select.vue?vue&type=template&id=163f1217&lang=pug"
import script from "./per_page_select.vue?vue&type=script&lang=js"
export * from "./per_page_select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports